/* eslint-disable @typescript-eslint/no-explicit-any */
import { ExperienceFilter, ExperienceFilters, TemplateFilters } from 'constants/UIConstants';
import { HelpCenterTopic } from 'types';
import AppConstants from 'constants/AppConstants';

interface UIState {
  controlPanelHeading: string;
  experienceFilter: ExperienceFilter;
  experiences: Dictionary<any>;
  helpCenterSelectedTopic?: HelpCenterTopic;
  showPacingPanel: boolean;
  pacingPanelTab: 'pacing' | 'apply-blocks' | 'remove-blocks' | 'remove-availability';
  showBusinessSwitcherModal: boolean;
  showCheckinDateSwitcherModal: boolean;
  showDeliveryDateSwitcherModal: boolean;
  showClearTemplatesModal: boolean;
  showDeviceStatusModal: boolean;
  showGlobalSearchModal: boolean;
  showHelpCenterModal: boolean;
  showKeyboardShortcutsModal: boolean;
  showReleasesModal: boolean;
  showUpcomingChangesModal: boolean;
  showSupportDrawer: boolean;
  showWaitlistReportRowModal: boolean;
  supplementGroups: Dictionary<any>;
  templateFilter: string;
}

const initialState: UIState = {
  controlPanelHeading: '',
  experienceFilter: ExperienceFilters.active,
  experiences: {},
  pacingPanelTab: 'apply-blocks',
  helpCenterSelectedTopic: undefined,
  showPacingPanel: false,
  showBusinessSwitcherModal: false,
  showCheckinDateSwitcherModal: false,
  showDeliveryDateSwitcherModal: false,
  showClearTemplatesModal: false,
  showDeviceStatusModal: false,
  showGlobalSearchModal: false,
  showHelpCenterModal: false,
  showKeyboardShortcutsModal: false,
  showReleasesModal: false,
  showUpcomingChangesModal: false,
  showSupportDrawer: false,
  showWaitlistReportRowModal: false,
  supplementGroups: {},
  templateFilter: TemplateFilters.active,
};

export default function reducer(state = initialState, action: BaseTockAction): UIState {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.UI_SET_CONTROL_PANEL_HEADING: {
      return {
        ...state,
        controlPanelHeading: payload,
      };
    }

    case AppConstants.UI_SET_EXPERIENCE_FILTER: {
      const experienceFilter = payload;
      return {
        ...state,
        experienceFilter,
      };
    }

    case AppConstants.UI_SET_TEMPLATE_FILTER: {
      const templateFilter = payload;
      return {
        ...state,
        templateFilter,
      };
    }

    case AppConstants.UI_SET_ARCHIVED_SUPPLEMENTS: {
      const { supplementGroupId, value } = payload;

      return {
        ...state,
        supplementGroups: {
          ...state.supplementGroups,
          [supplementGroupId]: {
            ...state.supplementGroups[supplementGroupId],
            showArchivedSupplements: value,
          },
        },
      };
    }

    case AppConstants.UI_SET_ARCHIVED_SUPPLEMENT_GROUPS: {
      const { experienceId, value } = payload;

      return {
        ...state,
        experiences: {
          ...state.experiences,
          [experienceId]: {
            ...state.experiences[experienceId],
            showArchivedSupplementGroups: value,
          },
        },
      };
    }

    case AppConstants.UI_SUPPORT_DRAWER: {
      return {
        ...state,
        showSupportDrawer: payload,
      };
    }

    case AppConstants.UI_PACING_PANEL_SHOW: {
      return {
        ...state,
        showPacingPanel: true,
      };
    }

    case AppConstants.UI_PACING_PANEL_TAB_UPDATE: {
      return {
        ...state,
        pacingPanelTab: payload,
      };
    }

    case AppConstants.UI_PACING_PANEL_HIDE: {
      return {
        ...state,
        showPacingPanel: false,
      };
    }

    case AppConstants.UI_TOGGLE_BUSINESS_SWITCHER_MODAL: {
      return {
        ...state,
        showBusinessSwitcherModal: payload,
      };
    }

    case AppConstants.UI_TOGGLE_CHECKIN_DATE_SWITCHER_MODAL: {
      return {
        ...state,
        showCheckinDateSwitcherModal: payload,
      };
    }

    case AppConstants.UI_TOGGLE_DELIVERY_DATE_SWITCHER_MODAL: {
      return {
        ...state,
        showDeliveryDateSwitcherModal: payload,
      };
    }

    case AppConstants.UI_TOGGLE_DEVICE_STATUS_MODAL: {
      return {
        ...state,
        showDeviceStatusModal: payload,
      };
    }

    case AppConstants.UI_TOGGLE_RELEASES_MODAL: {
      return {
        ...state,
        showReleasesModal: payload,
      };
    }

    case AppConstants.UI_TOGGLE_UPCOMING_CHANGES_MODAL: {
      return {
        ...state,
        showUpcomingChangesModal: payload,
      };
    }

    case AppConstants.UI_TOGGLE_GLOBAL_SEARCH_MODAL: {
      return {
        ...state,
        showGlobalSearchModal: payload,
      };
    }

    case AppConstants.UI_TOGGLE_HELP_CENTER_MODAL: {
      return {
        ...state,
        showHelpCenterModal: payload,
      };
    }

    case AppConstants.UI_SET_HELP_CENTER_TOPIC: {
      return {
        ...state,
        helpCenterSelectedTopic: payload,
      };
    }

    case AppConstants.UI_TOGGLE_WAITLIST_REPORT_ROW_MODAL: {
      return {
        ...state,
        showWaitlistReportRowModal: payload.isVisible,
      };
    }

    case AppConstants.UI_TOGGLE_CLEAR_TEMPLATES_MODAL: {
      return {
        ...state,
        showClearTemplatesModal: payload,
      };
    }

    default:
      return state;
  }
}
